// Mock data for Set Up Home Theater clone
import { serviceAreas } from "./serviceAreas";

export const PHOTO_SHOTS = [
  "The wall where the TV goes, straight on",
  "Both ends of the room",
  "Crawl space or attic access, open",
  "Breaker panel and the nearest outlet to the TV wall",
  "One wide shot of the whole room",
];

export const PHOTO_CHECKLIST = [
  "Sending photos of:",
  ...PHOTO_SHOTS.map((t, i) => `${i + 1}. ${t}`),
  "Wall width:",
  "Ceiling height:",
  "Seating distance:",
].join("\n");

export const AUDIO_PHOTO_CHECKLIST = [
  "Sending photos of (5-Shot Audio Site Survey Checklist):",
  "1. Equipment & Power Area: Where the receiver/TV/gear will sit, including nearby wall outlets and network ports.",
  "2. Current Gear & Wires: Back panel of your current receiver/soundbar or existing speaker wire connections.",
  "3. Speaker Placement & Ceiling: Target walls or ceiling where speakers will go, including ceiling height/type.",
  "4. Wire Path & Access: Attic hatch, crawl space access, or basement floor joists directly above/below the room.",
  "5. Wide Room / Outdoor Shot: A complete wide shot of the room or outdoor patio/yard area.",
].join("\n");

export const photoSmsLink = (intro, list = PHOTO_CHECKLIST) =>
  `sms:+12525450011?&body=${encodeURIComponent(`${intro}\n${list}`)}`;

export const company = {
  name: "Set Up Home Theater",
  phone: "(252) 545-0011",
  phoneLink: "tel:+12525450011",
  phoneLabel: "Call or text",
  cellSms: "sms:+12525450011",
  photoSms: photoSmsLink("Hi! I'd like a quote."),
  audioPhotoSms: photoSmsLink("Hi! I'd like an audio quote.", AUDIO_PHOTO_CHECKLIST),
  email: "chris@setuphometheater.com",
  location: "Rocky Mount, North Carolina",
  googleReview: "https://g.page/r/CfoWwSULqc7CEAI/review",
  logo: "https://customer-assets-m6fa6gv7.emergentagent.net/job_home-cinema-build/artifacts/ntpr30th_SHT-Logo-Tranparent-Txt.webp",
};

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  {
    label: "Services",
    to: "/services",
    children: [
      { label: "⚡ Instant TV Mount Quote", to: "/tv-mounting-quote" },
      { label: "TV Installation", to: "/services/tv-installation" },
      { label: "Audio Installation", to: "/services/audio-installation" },
      { label: "Home Cinema Theater", to: "/services/home-cinema" },
      { label: "Commercial AV", to: "/services/commercial-av" },
      { label: "Religious Venue Audio", to: "/services/religious-venue" },
      { label: "Smart Device Setup (Add-On)", to: "/services/smart-home" },
      { label: "Security Cameras (Add-On)", to: "/services/security-cameras" },
      { label: "Automated Shading (Lutron)", to: "/services/motorized-shading" },
    ],
  },
  {
    label: "Service Areas",
    to: "/service-areas",
    children: [
      { label: "Rocky Mount, NC", to: "/rocky-mount-nc" },
      ...serviceAreas.map((a) => ({ label: `${a.city}, NC`, to: `/${a.slug}-nc` })),
      { label: "All Service Areas →", to: "/service-areas" },
    ],
  },
  { label: "Recent Installs", to: "/recent-installs" },
  { label: "Contact Us", to: "/contact" },
  { label: "Blog", to: "/blog" },
];

export const heroServices = [
  { label: "TV installation", to: "/services/tv-installation" },
  { label: "Audio installation", to: "/services/audio-installation" },
  { label: "Home Cinema Theater installation", to: "/services/home-cinema" },
  { label: "Religious venues audio installation", to: "/services/religious-venue" },
];

export const heroImage =
  "https://static.prod-images.emergentagent.com/jobs/073631a6-db11-4316-b9b3-dbb48fef83fe/images/1f07c319a6f781161a7e2994317fcdb4b37cd2f047e284a98bc0e6768a4e2bbc.jpeg";

export const introImage =
  "https://images.unsplash.com/photo-1521607630287-ee2e81ad3ced";

export const services = [
  {
    id: "tv-installation",
    title: "TV Installation",
    image: "https://images.pexels.com/photos/6020432/pexels-photo-6020432.jpeg",
    desc: "Professional TV wall mounting, soundbar mounting, and clean cable management for a flawless finish.",
  },
  {
    id: "audio-installation",
    title: "Audio Installation",
    image:
      "https://images.unsplash.com/photo-1609702847389-b8aec1b0b929?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Whole-home audio, surround sound, and speaker installation tuned for the perfect listening experience.",
  },
  {
    id: "home-cinema",
    title: "Home Cinema",
    image:
      "https://images.unsplash.com/photo-1756729924227-06f63c7513e5?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Custom-designed home theaters with projectors, screens, immersive audio and cozy seating.",
  },
  {
    id: "commercial-av",
    title: "Commercial AV",
    image:
      "https://images.unsplash.com/photo-1766802981801-4b4a9a1d8f1c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    desc: "Displays, video walls, digital signage and zoned audio for offices, restaurants and venues.",
  },
  {
    id: "smart-home",
    title: "Smart Device Setup",
    image:
      "https://images.pexels.com/photos/22307556/pexels-photo-22307556.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Add-on setup for smart lighting, thermostats, doorbells and cameras — integrated with your AV.",
  },
  {
    id: "motorized-shading",
    title: "Motorized Shading (Lutron)",
    image:
      "https://images.unsplash.com/photo-1761330439180-2bba3bbb8eb2?crop=entropy&cs=srgb&fm=jpg&q=85",
    desc: "Lutron automated & wireless motorized shades — custom measured, designed and professionally installed.",
  },
  {
    id: "areas-we-serve",
    title: "Areas We Serve",
    image:
      "https://images.unsplash.com/photo-1567690187548-f07b1d7bf5a9",
    desc: "Serving Rocky Mount, Nash County and communities across Eastern North Carolina.",
  },
  {
    id: "rocky-mount-nc",
    title: "Rocky Mount & Nash County NC",
    image: "https://images.pexels.com/photos/7031762/pexels-photo-7031762.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    desc: "Your local, trusted home technology installers right here in Rocky Mount.",
    wide: true,
  },
  {
    id: "religious-venue",
    title: "Religious Venue Audio",
    image: "https://images.pexels.com/photos/37423127/pexels-photo-37423127.jpeg",
    desc: "Crystal-clear sound systems for churches, temples and worship venues of any size.",
    wide: true,
  },
];

export const steps = [
  {
    step: "STEP 1",
    title: "Choose a service and pricing package",
    desc: "Select the service you need and pick the pricing plan that fits your needs.",
  },
  {
    step: "STEP 2",
    title: "Request Installation",
    desc: "Provide your details and any specific requirements through a short form.",
  },
  {
    step: "STEP 3",
    title: "Receive confirmation email",
    desc: "We'll email you to confirm your request and provide further instructions.",
  },
  {
    step: "STEP 4",
    title: "Schedule a convenient time",
    desc: "Choose the best date and time for the service – we'll take it from there.",
  },
];

export const brands = [
  "SONOS",
  "SAMSUNG",
  "LG",
  "URC",
  "DENON",
  "SANUS",
  "Monitor Audio",
  "Russound",
];

export const whyChooseUs = [
  {
    icon: "BadgeCheck",
    title: "Certified Technicians",
    desc: "Our installers are trained, licensed and insured professionals you can trust in your home.",
  },
  {
    icon: "Clock",
    title: "Fast & On-Time",
    desc: "We respect your schedule with prompt arrivals and efficient, same-day installations.",
  },
  {
    icon: "Cable",
    title: "Clean Cable Management",
    desc: "No messy wires — we hide every cable for a seamless, professional finish.",
  },
  {
    icon: "Star",
    title: "Reviewed on Google",
    desc: "Don't take our word for it — read what real local customers say in our Google reviews.",
  },
  {
    icon: "ShieldCheck",
    title: "Licensed & Insured",
    desc: "Fully insured service for complete peace of mind on every job.",
  },
  {
    icon: "HeartHandshake",
    title: "Satisfaction Guaranteed",
    desc: "We're not done until you're 100% happy with your setup.",
  },
];

export const testimonials = [
  {
    name: "Greg Blackett",
    text: "Chris was great! I was having problems with an antenna installed by a friend. In my search for help I found Chris on Google and gave him a call. He came the next day, fixed my problem and gave me some insightful advice. Thanks so much!",
  },
  {
    name: "Greg Anstead",
    text: "He was very good and nice and went above and beyond with everything. The price was not bad at all. I will recommend him to anyone I know that needs TV installation.",
  },
  {
    name: "Richard Whitley",
    text: "Chris was great. He did an awesome job setting my system up. He was very knowledgeable, polite and prepared. He took his time to show me things about my system I was not aware of. I highly recommend him!",
  },
  {
    name: "Nathan Kacirek",
    text: "I really appreciate Chris's expertise and attention to detail in setting up our Nest thermostat, doorbell, and smoke detector. His knowledge made all the difference.",
  },
  {
    name: "Kevin Mcdavid",
    text: "Chris installed my Bose Lifestyle 28 5.1 surround sound system and did an awesome job. He was on time, thorough, and even came back to touch up the paint. Highly recommend Chris!",
  },
  {
    name: "Sara Elhanafy",
    text: "Amazing service! They installed my TV perfectly on the wall — super clean setup and all cables hidden. Professional, on time, and explained everything clearly. Highly recommend!",
  },
  {
    name: "John Gibbs",
    text: "Chris was great to work with and fixed my 20 yr outdoor speaker in 15 minutes. His response time and kindness was amazing and his quality of work top notch. I'll definitely call again!",
  },
  {
    name: "Jim Etheridge",
    text: "Chris is the best! My whole house audio system was really screwed up. He never gave up! Excellent communication, shows up on time, and saved me 2K from a previous quote. Thanks for your service Chris!",
  },
  {
    name: "Beth Rhyne",
    text: "Chris was great helping us with our new large TV and existing surround sound. Very knowledgeable about hooking up the new system with our old pieces. Reasonable pricing. Highly recommend!",
  },
];

export const blogPosts = [
  {
    id: "wall-mount-guide",
    title: "The Ultimate Guide to Mounting Your TV Like a Pro",
    date: "June 12, 2025",
    category: "TV Installation",
    image: "https://images.pexels.com/photos/6020432/pexels-photo-6020432.jpeg",
    excerpt:
      "Choosing the right bracket, finding studs, and hiding cables — everything you need to know before wall mounting your new TV.",
  },
  {
    id: "surround-sound",
    title: "How to Get Cinema-Quality Surround Sound at Home",
    date: "May 28, 2025",
    category: "Audio",
    image:
      "https://images.pexels.com/photos/5008383/pexels-photo-5008383.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    excerpt:
      "Speaker placement, calibration and room acoustics tips to transform your living room into a private theater.",
  },
  {
    id: "smart-home-2025",
    title: "Top Smart Home Upgrades Worth Investing In This Year",
    date: "May 10, 2025",
    category: "Smart Home",
    image:
      "https://images.pexels.com/photos/22307556/pexels-photo-22307556.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    excerpt:
      "From lighting automation to voice control, discover the smart home devices that add real value and convenience.",
  },
];

export const stats = [
  { value: "80+", label: "Industry-leading brands" },
  { value: "10+", label: "Years of experience" },
];
